import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

/**
 * Newsletter del lado cliente (S16). Público: `subscribeToNewsletter` no requiere sesión
 * por diseño — un suscriptor del boletín no es un usuario de la plataforma.
 *
 * Nada de esto toca Firestore directo: `newsletterSubscribers` está cerrada a cliente
 * (`allow read, write: if false`) y todo pasa por Cloud Functions con Admin SDK.
 */

/**
 * El idioma de alta se infiere del dominio/build (regla no negociable de
 * newsletter-sistema.md §3: "se infiere del build, no se adivina después"), NO del toggle
 * de idioma en vivo del navbar (useLanguage().language sí sigue ese toggle). Cada dominio
 * solo sirve su propio build, así que el hostname es un proxy fiel del build real — mismo
 * criterio que getInitialLanguage() en LanguageProvider.js.
 *
 * Vive acá y no en newsletter/index.js porque desde S16 la consumen dos lugares (la página
 * y NewsletterStrip.js) y una segunda copia es una copia que se desincroniza.
 */
export function getSiteLanguage() {
  if (typeof window === "undefined") return "es";
  return window.location.hostname.includes("voices-of-hope") ? "en" : "es";
}

/**
 * Alta con doble opt-in: manda el correo de confirmación y deja el doc en 'pending'.
 * `source`: 'strip' (franja del sitio) | 'page' (la página /newsletter/) | 'waitlist' |
 * 'home' | 'devotional' | 'card' | 'navbar'.
 * `lists` (opcional): ['devotional', 'newsletter']; sin él, solo el boletín.
 * Devuelve { success, alreadyConfirmed? }.
 */
export async function subscribeToNewsletter(email, language, source, lists) {
  const subscribe = httpsCallable(functions, "subscribeToNewsletter");
  const payload = { email: email.trim(), language, source };
  if (lists) payload.lists = lists;
  const result = await subscribe(payload);
  return result.data;
}

/**
 * Alta o baja para alguien con sesión — la función usa el correo verificado de la cuenta,
 * nunca uno que mande el cliente, así que no recibe email como parámetro (y no debe
 * recibirlo: sería la puerta para suscribir a terceros).
 *
 * El alta entra directo como 'confirmed', sin segundo correo: esa dirección ya fue
 * verificada al crear la cuenta. `list`: 'newsletter' (por defecto) | 'devotional' — solo
 * cambia esa lista. Devuelve { success, status, list }.
 */
export async function setMyNewsletterSubscription(subscribed, list = "newsletter") {
  const setSubscription = httpsCallable(functions, "setMyNewsletterSubscription");
  const result = await setSubscription({ subscribed, list });
  return result.data;
}
